module.exports = __webpack_public_path__ + "img/book-read.8086492e.svg";